if (!customElements.get('pt-product-shipping')) {
  customElements.define('pt-product-shipping', class extends HTMLElement {
    connectedCallback() {
      this.message = this.querySelector('[data-shipping-message]');
      this.progress = this.querySelector('[data-shipping-progress]');
      this.threshold = Number(this.dataset.threshold);
      this.refresh = this.refresh.bind(this);
      this.onPageShow = (event) => { if (event.persisted) this.refresh(); };
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, this.refresh);
      window.addEventListener('pageshow', this.onPageShow);
      this.refresh();
    }

    disconnectedCallback() {
      this.unsubscribe?.();
      this.controller?.abort();
      window.removeEventListener('pageshow', this.onPageShow);
    }

    async refresh() {
      this.controller?.abort();
      const controller = new AbortController();
      this.controller = controller;
      try {
        const response = await fetch(this.dataset.cartUrl, {
          signal: controller.signal,
          cache: 'no-store',
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) throw new Error('Cart unavailable');
        const cart = await response.json();
        if (controller.signal.aborted || !this.isConnected) return;
        if (cart.currency !== 'EUR' || !Number.isFinite(cart.total_price)) {
          this.hidden = true;
          return;
        }
        const total = Math.max(0, cart.total_price);
        const remaining = Math.max(0, this.threshold - total);
        const empty = cart.item_count === 0 || !cart.requires_shipping;
        const amount = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
          style: 'currency',
          currency: 'EUR'
        }).format(remaining / 100);
        const message = empty ? this.dataset.empty :
          remaining === 0 ? this.dataset.unlocked : this.dataset.remaining.replace('[amount]', amount);
        if (this.message.textContent.trim() !== message) this.message.textContent = message;
        this.progress.style.width = empty ? '0%' : Math.min(100, total / this.threshold * 100) + '%';
        this.hidden = false;
      } catch (error) {
        if (error.name !== 'AbortError') this.hidden = true;
      }
    }
  });
}
